import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/Loader"
import React, { useEffect, useState } from "react"
import { FaClock, FaMapMarkerAlt, FaUsers } from "react-icons/fa"
import { MdLocationOff } from "react-icons/md"
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap"
import WelcomeComp from "./WelcomeComp"
import { fetchData, FetchPostData } from "utils/Common_api_functions"
import { FaArrowTrendUp } from "react-icons/fa6"
import moment from "moment"
import secureLocalStorage from "react-secure-storage"

const Dashboard = () => {
  const [loading, setLoading] = useState(false)
  const [dashboardCounts, setDashboardCounts] = useState({})
  const [dashboardData, setDashboarddata] = useState({})
  const [punchDetails, setPunchDetails] = useState([])

  const user = secureLocalStorage?.getItem("admin_user")

  useEffect(() => {
    getDashboardCounts()
    fetchPunches()
  }, [])

  async function getDashboardCounts() {
    const APIdata = await fetchData(setLoading, "dashboard/counts")
    if (APIdata?.success) {
      setDashboardCounts(APIdata.data)
    }

    const APIData2 = await FetchPostData(
      setLoading,
      "dashboard/leads/and/leaves",
      { userId: user?.id }
    )
    if (APIData2?.data?.success) {
      setDashboarddata(APIData2?.data?.data)
    }
  }

  const fetchPunches = async () => {
    const res = await fetchData(setLoading, "attendance")
    if (res?.success) {
      const today = new Date().toISOString().split("T")[0]
      const filtered = res.data.filter(item => item.inDate === today)
      setPunchDetails(filtered)
    }
  }

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={"Dashboards"} breadcrumbItem={"Dashboard"} />

          {/* Top stats cards */}
          <Row className="px-0">
            <Col xl={3}>
              <WelcomeComp />
            </Col>
            {/* Total Employees */}
            <Col md="3">
              <Card className="mini-stats-wid mb-3 shadow-lg">
                <CardBody className="d-flex align-items-center justify-content-between p-3">
                  <div>
                    <h3 className="mb-2 fw-bold">{dashboardCounts?.users}</h3>
                    <h6>Total Employees</h6>
                  </div>
                  <div className="avatar-sm rounded-circle mini-stat-icon">
                    <span className="avatar-title rounded-circle">
                      <FaUsers fontSize={24} />
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* Completed Locations */}
            <Col md="3">
              <Card className="mini-stats-wid mb-3 shadow-lg">
                <CardBody className="d-flex align-items-center justify-content-between p-3">
                  <div>
                    <h3 className="mb-2 fw-bold">
                      {dashboardCounts?.activePunch - 1}
                    </h3>
                    <h6>Working Employees</h6>
                  </div>
                  <div className="avatar-sm rounded-circle mini-stat-icon">
                    <span className="avatar-title rounded-circle">
                      <FaClock fontSize={24} />
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* Remaining Locations */}
            <Col md="3">
              <Card className="mini-stats-wid mb-3 shadow-lg">
                <CardBody className="d-flex align-items-center justify-content-between p-3">
                  <div>
                    <h3 className="mb-2 fw-bold">
                      {dashboardCounts?.leads || 0}
                    </h3>
                    <h6>Leads</h6>
                  </div>
                  <div className="avatar-sm rounded-circle mini-stat-icon">
                    <span className="avatar-title rounded-circle">
                      <FaArrowTrendUp fontSize={24} />
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <h5>Today's Follow Up</h5>
                  <Table className="bg-white" striped>
                    <thead className="table-dark">
                      <tr>
                        <td>#</td>
                        <td>Company</td>
                        <td>Contact Person</td>
                        <td>Email</td>
                        <td>Phone</td>
                        <td>Source</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan={6} className="text-center">
                          No Follow Ups Today
                        </td>
                      </tr>
                      {/* {dashboardData?.todayFollowUps?.length === 0 && (
                        <tr>
                          <td colSpan={6}>No Follow Ups Today</td>
                        </tr>
                      )}
                      {dashboardData?.todayFollowUps?.map((item, index) => (
                        <tr key={index}>
                          <td>1.</td>
                          <td>Shah</td>
                          <td>Shah</td>
                          <td>Shah</td>
                          <td>Shah</td>
                          <td>Shah</td>
                        </tr>
                      ))} */}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>

            <Col xl={6}>
              <Card>
                <CardBody>
                  <h5>Active Punches</h5>
                  <Table striped>
                    <thead className="table-dark">
                      <tr>
                        <td>#</td>
                        <td>Person Name</td>
                        <td>In Time</td>
                        <td>In Location</td>
                      </tr>
                    </thead>
                    <tbody>
                      {punchDetails?.length === 0 && (
                        <tr>
                          <td colSpan={4} className="text-center">
                            No Active Punches
                          </td>
                        </tr>
                      )}
                      {punchDetails?.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item?.user}</td>
                          <td>{item?.inTime}</td>
                          <td>{item?.punchInAddress}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
            <Col xl={6}>
              <Card>
                <CardBody>
                  <h5>Absent Employees ({moment().format("DD/MM/YYYY")})</h5>
                  <Table striped>
                    <thead className="table-dark">
                      <tr>
                        <td>#</td>
                        <td>Person Name</td>
                        <td>Leave Type</td>
                      </tr>
                    </thead>
                    <tbody>
                      {dashboardData?.absentEmployees?.length === 0 && (
                        <tr>
                          <td colSpan={3}>No absent Today</td>
                        </tr>
                      )}
                      {dashboardData?.absentEmployees?.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item?.name}</td>
                          <td>{item?.type || "Absent"}</td>
                        </tr>
                      ))}
                      {dashboardData?.employeeOnTodayLeave?.map(
                        (item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item?.user?.name}</td>
                            <td className="text-capitalize">
                              {item?.type || "Absent"}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Dashboard
